import { generateResourceReducer } from '../generators/resource.reducer';

import * as types from './notification.types';
import * as constants from './notification.constants';

export const notificationReducer = generateResourceReducer<types.INotification>({
  STORE: constants.STORE_NOTIFICATION,
  CLEAR: constants.CLEAR_NOTIFICATION,
});
